import React from 'react'

import { AnimatePresence } from 'motion/react'

import {
  CardAssigned,
  type CardAssignedAction,
  type CardAssignedData,
  type CardAssignedLabels,
  type CardAssignedOptions,
  type CardAssignedState,
  type CardAssignedTimeFormat,
} from '@/components/molecules/CardAssigned/CardAssigned.tsx'
import { type CardListState, cardStateInList } from '@/components/organisms/CardList/CardListState.ts'
import { cn } from '@/lib/utils.ts'

export type CardListAssignedTimeFormat = CardAssignedTimeFormat

export type CardListAssignedOptions = CardAssignedOptions

export interface CardListAssignedLabels extends CardAssignedLabels {}

export type CardListAssignedData = Array<CardAssignedData & { id: string }>

export interface CardListAssignedActions {
  onActivate: (requestId: string) => void
  onAllocateManually: (requestId: string) => void
  onCancelRequest: (requestId: string, ...args: Parameters<CardAssignedAction['onCancelRequest']>) => void
  onPutOnHold: (requestId: string, ...args: Parameters<CardAssignedAction['onCancelRequest']>) => void
}

export interface CardListAssignedProps
  extends
    React.HtmlHTMLAttributes<HTMLDivElement>,
    CardListAssignedTimeFormat,
    CardListAssignedActions,
    Pick<CardAssignedState, 'size'> {
  labels: CardListAssignedLabels
  options: CardListAssignedOptions
  data?: CardListAssignedData
  state?: CardListState
}

export const CardListAssigned = React.forwardRef<HTMLDivElement, CardListAssignedProps>(
  (
    {
      className,
      labels,
      options,
      data = [],
      state,
      size,
      timeAgoFormatter,
      onActivate,
      onCancelRequest,
      onAllocateManually,
      onPutOnHold,
      ...props
    },
    ref
  ) => (
    <div className={cn('flex flex-col', className)} ref={ref} {...props}>
      <AnimatePresence initial={false}>
        {data.map((card) => (
          <CardAssigned
            {...card}
            key={card.id}
            labels={labels}
            options={options}
            size={size}
            state={cardStateInList(card.id, state)}
            highlighted={state?.highlighted === card.id}
            timeAgoFormatter={timeAgoFormatter}
            onClick={() => {
              if (!['selected', 'disabled'].includes(cardStateInList(card.id, state))) {
                onActivate(card.id)
              }
            }}
            onCancelRequest={(value) => {
              onCancelRequest(card.id, value)
            }}
            onAllocateManually={() => {
              onAllocateManually(card.id)
            }}
            onPutOnHold={(value) => {
              onPutOnHold(card.id, value)
            }}
          />
        ))}
      </AnimatePresence>
    </div>
  )
)
